import ProductIcon from '@mui/icons-material/Collections';
import { useTranslate } from 'react-admin';

import CardWithIcon from './CardWithIcon';

interface Props {
    value?: string;
}

const AnalysisOfSharesPending = (props: Props) => {
    const { value } = props;
    const translate = useTranslate();
    return (
        <CardWithIcon
            to='/analysisOfShares?filter={"sendToResponsibleForAnalysis":true,"sendToResponsibleForImplementation":false,"dateOfFormationOfWorkTeam":null}'
            icon={ProductIcon}
            title={translate('resources.dashboard.analysisOfSharesPending')}
            subtitle={value}
        />
    );
};

export default AnalysisOfSharesPending;